import { createSlice } from '@reduxjs/toolkit';
import { SearchForm } from '../SearchForm';
import { RootState } from '.';

export type SearchState = {
  searchForm: SearchForm;
};

export const initialState: SearchState = {
  searchForm: new SearchForm(),
};

const searchSlice = createSlice({
  name: 'searchState',
  initialState,
  reducers: {
    UpdateSearchForm: (state, action: any) => {
      state.searchForm = action.payload;
    },
    CreatSearchForm: (state, action: any) => {
      state.searchForm = new SearchForm();
    },
  },
  extraReducers: {},
});

export const { UpdateSearchForm, CreatSearchForm } = searchSlice.actions;
// export searchSlice selector to get the slice in any component
export const SearchSelector = (state: RootState) => state.searchState;
// export The reducer
const searchReducer = searchSlice.reducer;
export default searchReducer;
